import React, { useState } from "react";
import AnimationPage from "../../shared/animation-page/AnimationPage";
import axios from "axios";
import DeleteWebhookModal from "./DeleteWebhookModal";
import EditWebhookModal from "./EditWebhookModal";

import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
} from "@mui/material";
import Button from "../../design/Button";
import GModal from "../../design/components/GModal";
import CreateWebhook from "./CreateWebhook";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { enqueueSnackbar } from "notistack";
import { AUTO_CANCELLED } from "../../../utility-functions";
import { useSelector } from "react-redux";

const BASE_URL = process.env.REACT_APP_BETA;
const CREATE_URL = `${BASE_URL}/api/v2/integrations/create-webhook/`;
const DELETE_URL = `${BASE_URL}/api/v2/integrations/webhook/`;


const WebHookDetails = ({
  countWebhook,
  webhooks,
  createWebhook,
  handleOpen,
  handleClose,
  isRedirectUrlValid,
  flag,
  setFlag,
  encoded,
  hookloading,
}) => {
  const reduxAccount = useSelector((state) => state?.account?.value);
  
  const [isValid, setIsValid] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  const [pocEmails, setPocEmails] = useState([]);
  const [eventType, setEventType] = useState("");
  const [headers, setHeaders] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuWebhookIndex, setMenuWebhookIndex] = useState(null);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [webhookToDelete, setWebhookToDelete] = useState(null);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [selectedWebhook, setSelectedWebhook] = useState(null);
  const [editSave, setEditSave] = useState(false);

  // CREATE WEBHOOK
  const handleSave = () => {
    console.log("Headers before filter:", headers);
    const clean_headers = headers.reduce((foo, { key, value }) => {
      if (key && value) foo[key] = value;
      return foo;
    }, {});
    console.log("Headers after filter:", clean_headers);

    const payload = {
      event: eventType,
      callback_url: redirectUrl,
      custom_headers: clean_headers,
      poc_emails: pocEmails
    };

    axios
      .post(CREATE_URL, payload, {
        headers: {
          Authorization: `Bearer ${encoded}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("Webhook created:", res);
        enqueueSnackbar("Webhook created successfully", { variant: "success" });
        setFlag(flag === 1 ? 0 : 1);
        handleClose();
        setRedirectUrl("");
        setEventType("");
        setHeaders([]);
        setPocEmails([])
      })
      .catch((error) => {
        console.error("Failed to create webhook:", error);
        enqueueSnackbar("Webhook create failed", { variant: "error" });
        handleClose();
      });
  };
  const handleMenuOpen = (event, index) => {
    setAnchorEl(event.currentTarget);
    setMenuWebhookIndex(index);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuWebhookIndex(null);
  };
  // DELETE
  const openDeleteModal = (index) => {
    setWebhookToDelete(webhooks[index]);
    setDeleteModalVisible(true);
    handleMenuClose();
  };
  const handleDelete = () => {
    if (!webhookToDelete?.id) {
      enqueueSnackbar("Missing required info to delete webhook", {
        variant: "error",
      });
      return;
    }
    axios
      .delete(`${DELETE_URL}${webhookToDelete.id}/`, {
        headers: {
          Authorization: `Bearer ${encoded}`,
        },
      })
      .then((res) => {
        console.log("Webhook deleted:", res);
        enqueueSnackbar("Webhook deleted successfully", { variant: "success" });
        setDeleteModalVisible(false);
        setFlag((prev) => prev + 1); // Trigger refresh or refetch webhooks
      })
      .catch((err) => {
        console.error("Failed to delete webhook:", err);
        enqueueSnackbar("Failed to delete webhook", { variant: "error" });
        setDeleteModalVisible(false);
      });
  };
  const openEditModal = (index) => {
    const selected = webhooks[index];

    const headersArray = Object.entries(selected.custom_headers || {}).map(
      ([key, value]) => ({ key, value })
    );

    setSelectedWebhook({
      ...selected,
      headers: headersArray, // this makes headers editable in modal
    });

    setEditModalVisible(true);
    handleMenuClose();
  };

  const handleCancel = () =>{
        handleClose();
        setRedirectUrl("");
        setEventType("");
        setHeaders([]);
        setPocEmails([]); 
  };
  const handleEditSave = () => {
    const { id, callback_url, active, headers, poc_emails } = selectedWebhook;

    // Convert headers array to object
    const customHeaders = (headers || []).reduce((acc, { key, value }) => {
      if (key && value) acc[key] = value;
      return acc;
    }, {});

    const payload = {
      callback_url,
      active,
      custom_headers: customHeaders,
      poc_emails
    };
    // UPDATE
    axios
      .patch(`${BASE_URL}/api/v2/integrations/webhook/${id}/`, payload, {
        headers: {
          Authorization: `Bearer ${encoded}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("Webhook updated:", res);
        enqueueSnackbar("Webhook updated successfully", { variant: "success" });
        setEditModalVisible(false);
        setFlag((prev) => prev + 1);
      })
      .catch((err) => {
        console.error("Failed to update webhook:", err);
        enqueueSnackbar("Webhook update failed", { variant: "error" });
      });
  };

  return (
    <>
      {hookloading ? (
        <AnimationPage variant="transparent" height="180px" />
      ) : (
        <Box className="element" sx={{ p: 1 }} mt={3} mb={3}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            mb={2} // optional spacing
          >
            <Typography
              variant="h6"
              sx={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 500,
                fontSize: "18px",
                lineHeight: "28px",
                letterSpacing: "0%",
              }}
            >
              Webhooks
            </Typography>

            {countWebhook !== 0 && (
              <Button 
                buttonText="Create webhook"
                onClick={handleOpen}
                variant="contained"
                hierarchy="green"
                styleOverride={{width: '143px', padding: '16px 8px', fontWeight: '500'}}
                disabled={reduxAccount?.subscription?.status === AUTO_CANCELLED}
              />
            )}
          </Box>

          {countWebhook === 0 ? (
            <Box>
              <Typography
                variant="body2"
                color="text.secondary"
                mb={2}
                sx={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "20px",
                  letterSpacing: "0%",
                }}
              >
                Receive HTTP request whenever an event is triggered.
              </Typography>
              <Button 
                buttonText="Create webhook"
                onClick={handleOpen}
                variant="contained"
                hierarchy="green"
                disabled={reduxAccount?.subscription?.status === AUTO_CANCELLED}
                styleOverride={{width: '143px', padding: '16px 8px', fontWeight: '500'}}
              />
            </Box>
          ) : (
            <TableContainer component={Paper} className="app-container">
              <Table>
                <TableHead sx={{ backgroundColor: "#f7f9f8", color: '#3F3F46'}}>
                  <TableRow>
                    <TableCell>
                      <Typography sx={{fontSize: "14px", lineHeight: '20px',fontWeight: '500', color: '#3F3F46'}}>Event type</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography sx={{fontSize: "14px", lineHeight: '20px',fontWeight: '500', color: '#3F3F46'}}>URL</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography sx={{fontSize: "14px", lineHeight: '20px',fontWeight: '500', color: '#3F3F46'}}>Headers</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography sx={{fontSize: "14px", lineHeight: '20px',fontWeight: '500', color: '#3F3F46'}}>Status</Typography>
                    </TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {webhooks.map((webhook, index) => (
                    <TableRow
                      key={webhook.id}
                      sx={{
                        backgroundColor: "#ffffff",
                        "&:hover": {
                          backgroundColor: "#f7f9f8",
                          "& .menu-button": {
                            visibility: "visible",
                          },
                        },
                      }}
                    >
                      <TableCell>{webhook.event}</TableCell>
                      <TableCell>{webhook.callback_url}</TableCell>
                      <TableCell>
                        {webhook.custom_headers
                          ? Object.keys(webhook.custom_headers).length
                          : 0}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={webhook.active ? "Active" : "Inactive"}
                          size="small"
                          sx={{
                            backgroundColor: webhook.active
                              ? "rgba(0, 200, 83, 0.1)"
                              : "rgba(255, 193, 7, 0.15)",
                            color: webhook.active
                              ? "success.main"
                              : "warning.main",
                            fontWeight: 500,
                            borderRadius: "8px",
                          }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginRight: 6,
                          }}
                        >
                          <IconButton
                            size="small"
                            onClick={(e) => handleMenuOpen(e, index)}
                            sx={{
                              visibility: "hidden",
                              backgroundColor: "#fff",
                              border: "1px solid #e0e0e0",
                              borderRadius: "8px",
                              padding: "4px",
                              transform: "rotate(90deg)",
                              "&:hover": {
                                backgroundColor: "#f5f5f5",
                              },
                            }}
                            className="menu-button"
                          >
                            <MoreVertIcon fontSize="small" />
                          </IconButton>
                        </Box>

                        {menuWebhookIndex === index && (
                          <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "right",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                          >
                            <MenuItem onClick={() => openEditModal(index)}>
                              Edit
                            </MenuItem>
                            <MenuItem onClick={() => openDeleteModal(index)}>
                              Delete
                            </MenuItem>
                          </Menu>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      )}
      <GModal
        visible={createWebhook}
        closeModal={handleClose}
        heading="Create webhook"
        footerLeft={
  <a
    href="https://frejun.com/docs/webhooks/create-webhook/"
    className="gmodal-footer-link"
  >
    View docs
  </a>
        }
        modalStyle={{
          width: "448px",
          minHeight: "290px",
          maxHeight: '350px',
          padding: "24px 32px",
          gap: "20px",
          display: "flex",
          flexDirection: "column",
          boxSizing: "border-box",
        }}
        body={
          <CreateWebhook
            redirectUrl={redirectUrl}
            setRedirectUrl={setRedirectUrl}
            pocEmails={pocEmails}
            setPocEmails={setPocEmails}
            eventType={eventType}
            setEventType={setEventType}
            headers={headers}
            setHeaders={setHeaders}
            isRedirectUrlValid={isRedirectUrlValid}
            isValid={isValid}
            setIsValid={setIsValid}
          />
        }
        bottomButtons={[
              <Button
                buttonText="Cancel"
                onClick={handleCancel}
                variant="outlined"
                hierarchy="white"
                styleOverride={{width: '75px', height: '36px', fontWeight: '500'}}
              />,
              <Button
                buttonText="Create"
                disabled={!isValid}
                onClick={handleSave}
                variant="contained"
                hierarchy="green"
                styleOverride={{width: '73px', height: '36px', fontWeight: '500'}}
              />
        ]}
      />
      <DeleteWebhookModal
        visible={deleteModalVisible}
        closeModal={() => setDeleteModalVisible(false)}
        onDelete={handleDelete}
        webhookName={webhookToDelete?.eventType || "this webhook"}
      />
      {selectedWebhook && (
        <EditWebhookModal
          visible={editModalVisible}
          closeModal={() => setEditModalVisible(false)}
          webhook={selectedWebhook}
          setWebhook={setSelectedWebhook}
          onSave={handleEditSave}
          editSave={editSave}
          setEditSave={setEditSave}
          isRedirectUrlValid={isRedirectUrlValid}
        />
      )}
    </>
  );
};

export default WebHookDetails;
